<template>
  <div class="block-banners" v-if="!!bannerList">
    <div
      class="item-block"
      v-for="(item, idx) in bannerList"
      :key="`${idx}`"
      :class="{
        'large-banner': item.type === bannerType.largeBanner,
      }"
      @click="onBannerClick(idx)"
    >
      <span class="extend-body" v-if="!!item.extend_body && item.extend_body.length > 0" v-html="item.extend_body" />
      <img :src="item.img_url" :alt="item.memo" v-else>
    </div>
  </div>
</template>

<script>
import { BANNER_TYPE } from '@/utvStore/components/recommend/lp/statics'

export default {
  name: 'BannerBlock',
  props: {
    bannerList: {
      type: Array,
    }
  },
  data() {
    return {
      bannerType: BANNER_TYPE,
    }
  },
  methods: {
    onBannerClick(val){
      const dt = this.bannerList[val]
      if(dt.outerLink){
        window.open(dt.url, '_blank')
      }else{
        location.href = dt.url
      }
    }
  },
}
</script>

<style scoped lang="scss">
.block-banners {
  background: white;
  padding: 40px 20px 65px;
  .item-block {
    display: block;
    margin-bottom: 20px;
    padding: 0 20px;
    cursor: pointer;
    &.large-banner {
      padding: 0;
      margin-bottom: 24px;
    }
  }
}
/deep/ {
  .caption {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #32373F;
    margin-top: 10px;
    display: block;
  }
  .price {
    color: #fe7397;
    font-weight: 600;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/partials/BannerBlock.vue